import { Navigate } from 'react-router';
import Auth from 'containers/Auth';
import NotFound from 'containers/NotFound';
import Points from 'containers/Points/Points';
import Requests from 'containers/Requests/Requests';
import Point from 'containers/Point/Point';
import Profile from 'containers/Profile/Profile';
import Brands from 'containers/Brands/Brands';
import Brand from 'containers/Brand/Brand';
import Reviews from 'containers/Reviews/Reviews';
import Request from 'containers/Request/Request';
import { RouteItem } from 'components/Core/CustomRoute/types';
import ServerError from 'components/Core/ServerError/ServerError';
import AdminUsers from 'containers/AdminUsers/AdminUsers';
import Products from 'containers/Products/Products';
import Product from 'containers/Product/Product';
import Parsers from 'containers/Parsers/Parsers';
import EditParser from 'containers/EditParser/EditParser';
import AddParser from 'containers/AddParser/AddParser';
import Countries from 'containers/Countries/Countries';
import Country from 'containers/Country/Country';
import PopularProducts from 'containers/PopularProducts/PopularProducts';
import PopularProduct from 'containers/PopularProduct/PopularProduct';
import Categories from 'containers/Categories/Categories';
import Category from 'containers/Category/Category';
import Scripts from 'containers/Scripts/Scripts';
import Script from 'containers/Script/Script';
import SearchCoverage from 'containers/SearchCoverage/SearchCoverage';

export const commonRoutes: RouteItem[] = [
  { path: '/', component: null, isPrivate: true },
  { path: '/login', component: <Auth />, disableNavbar: true },
  { path: '/profile', component: <Profile />, isPrivate: true },
  { path: '*', component: <NotFound /> },
];

export const requestsManagerRoutes: RouteItem[] = [
  { path: '/requests', component: <Navigate to='brands' replace />, isPrivate: true },
  { path: '/requests/:entity', component: <Requests />, isPrivate: true },
  { path: '/requests/:entity/:id', component: <Request />, isPrivate: true },
];

export const polygonsManagerRoutes: RouteItem[] = [
  { path: '/brands', component: <Brands />, isPrivate: true },
  { path: '/brands/add', component: <Brand />, isPrivate: true },
  { path: '/brands/:id', component: <Navigate to='catalogues' replace />, isPrivate: true },
  { path: '/brands/:id/catalogues', component: <Brand />, isPrivate: true },
  { path: '/brands/:id/catalogues/:catalogueId', component: <Brand />, isPrivate: true },
  { path: '/brands/:id/catalogues/:catalogueId/pages/:pageNumber', component: <Brand />, isPrivate: true },
];

export const pointsManagerRoutes: RouteItem[] = [
  { path: '/points', component: <Points />, isPrivate: true },
  { path: '/points/add', component: <Point />, isPrivate: true },
  { path: '/points/:id', component: <Navigate to='basic' replace />, isPrivate: true },
  { path: '/points/:id/basic', component: <Point />, isPrivate: true },
  // { path: '/points/:id/categories', component: <Point />, isPrivate: true },
  // { path: '/points/:id/categories/add', component: <Point />, isPrivate: true },
  // { path: '/points/:id/categories/:catId', component: <Point />, isPrivate: true },
  // { path: '/points/:id/schedule', component: <Point />, isPrivate: true },
  // { path: '/points/:id/admins', component: <Point />, isPrivate: true },
  // { path: '/points/:id/logs', component: <Point />, isPrivate: true },
  // { path: '/points/add/basic', component: <Navigate to='/points/add' replace />, isPrivate: true },
  // { path: '/points/add/products', component: <Navigate to='/points/add' replace />, isPrivate: true },
  // { path: '/points/add/products/:prodId', component: <Navigate to='/points/add' replace />, isPrivate: true },
  // { path: '/points/add/categories', component: <Navigate to='/points/add' replace />, isPrivate: true },
];

export const adminRoutes: RouteItem[] = [
  { path: '/admin-users', component: <AdminUsers />, isPrivate: true },
  // brands
  { path: '/brands', component: <Brands />, isPrivate: true },
  { path: '/brands/add', component: <Brand />, isPrivate: true },
  { path: '/brands/:id', component: <Navigate to='basic' replace />, isPrivate: true },
  { path: '/brands/:id/basic', component: <Brand />, isPrivate: true },
  { path: '/brands/:id/catalogues', component: <Brand />, isPrivate: true },
  { path: '/brands/:id/catalogues/:catalogueId', component: <Brand />, isPrivate: true },
  { path: '/brands/:id/catalogues/:catalogueId/pages/:pageNumber', component: <Brand />, isPrivate: true },
  // products
  { path: '/products', component: <Products />, isPrivate: true },
  { path: '/products/add', component: <Product />, isPrivate: true },
  { path: '/products/:id', component: <Navigate to='basic' replace />, isPrivate: true },
  { path: '/products/:id/basic', component: <Product />, isPrivate: true },
  // reviews
  { path: '/reviews', component: <Reviews />, isPrivate: true },
  { path: '/popular-products', component: <PopularProducts />, isPrivate: true },
  { path: '/popular-products/:id', component: <PopularProduct />, isPrivate: true },
  { path: '/popular-products/add', component: <PopularProduct />, isPrivate: true },
  // categories
  { path: '/categories', component: <Navigate to='points-categories' replace />, isPrivate: true },
  { path: '/categories/:entity', component: <Categories />, isPrivate: true },
  { path: '/categories/:entity/:id', component: <Navigate to='translations' replace />, isPrivate: true },
  { path: '/categories/:entity/:id/:tab', component: <Category />, isPrivate: true },
  ...pointsManagerRoutes,
  ...requestsManagerRoutes,
];

export const superAdminRoutes: RouteItem[] = [
  { path: '/parsers', component: <Parsers />, isPrivate: true },
  { path: '/parsers/:id', component: <EditParser />, isPrivate: true },
  { path: '/add-parser', component: <AddParser />, isPrivate: true },
  { path: '/countries', component: <Countries />, isPrivate: true },
  { path: '/countries/:id', component: <Country />, isPrivate: true },
  { path: '/countries/add', component: <Country />, isPrivate: true },
  { path: '/scripts', component: <Scripts />, isPrivate: true },
  // { path: '/scripts/:type/:id', component: <Navigate to='basic' replace />, isPrivate: true },
  { path: '/scripts/:type/:id', component: <Script />, isPrivate: true },
  { path: '/search-coverage', component: <SearchCoverage />, isPrivate: true },
  { path: '/error', component: <ServerError />, isPrivate: false },
  ...adminRoutes,
  ...pointsManagerRoutes,
  ...requestsManagerRoutes,
];
